import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Context } from '../../../../../Context';
import CustomToolTip from '../../../../ToolTipInfoCustomMUI';
import Zoom from '@mui/material/Zoom';
import styles from '../../../../../styles/aprt.module.scss';

/**
 * InfoMode Renderer - Displays compartments as grid tiles
 * Click on tile expands detailed info below
 * 
 * @param {Object} compartment - Compartment data
 * @param {Function} onClick - Click handler
 * @param {Function} onHover - Hover handler (enter)
 * @param {Function} onHoverLeave - Hover handler (leave)
 * @param {boolean} isSelected - Is this compartment selected
 * @param {boolean} isHovered - Is this compartment hovered
 * @param {Function} formatArea - Area formatting function
 * @param {Function} getClassName - ClassName getter function
 */
function InfoModeRenderer({
	compartment,
	onClick,
	onHover,
	onHoverLeave,
	isSelected,
	isHovered,
	formatArea,
	getListDtClassName,
	getListDdClassName,
	getListRowClassName,
}) {
	const { t } = useTranslation();

	return (
		<div
			className={getListRowClassName(compartment.number)}
			onClick={onClick}
			onMouseEnter={onHover}
			onMouseLeave={onHoverLeave}
			style={{
				cursor: 'pointer',
			}}
		>
			<dt className={getListDtClassName(compartment.number)}>
				{compartment.name}:
			</dt>
			<dd className={getListDdClassName(compartment.number)}>
				{formatArea(compartment.area)} m<sup>2</sup>
			</dd>
		</div>
	);
}

export default InfoModeRenderer;
